var exports = {
  "k": "x620889e6--e5eea0--container",
};

module.exports = exports;
